import { FaFacebookSquare } from "react-icons/fa";

const FACEBOOK_PAGE_URL = "https://web.facebook.com/p/Atlantis-Fish-100063624968667/?locale=fi_FI&_rdc=1&_rdr#";

const facebookVideos = [
  // Pega aquí las URLs de tus videos
  "https://i.imgur.com/zd4OIsb.mp4",
  "https://i.imgur.com/0OPr2YO.mp4",
  "https://i.imgur.com/b1Tr0au.mp4",
  "https://i.imgur.com/g3oSSRh.mp4",
  "https://i.imgur.com/Jo5mlAC.mp4",
  "https://i.imgur.com/hnVRN4X.mp4",
  "https://i.imgur.com/oIVPhbb.mp4",
  "https://i.imgur.com/AvulQfn.mp4",
];

export default function FacebookVideosSection() {
  return (
    <section className="container mx-auto my-12 text-center">
      <h2 className="text-3xl font-bold text-primary flex items-center justify-center gap-3 mb-2">
        <FaFacebookSquare className="text-blue-700 text-4xl" />
        Síguenos en Facebook
      </h2>
      <p className="text-base text-textSecondary max-w-3xl mx-auto mb-8">
        Mira nuestros videos, concursos y tips en <b>Facebook</b>. Haz clic en cualquier video para ver más.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {facebookVideos.map((videoSrc, idx) => (
          <div
            key={idx}
            className="relative group rounded-xl overflow-hidden shadow-xl cursor-pointer transition-transform hover:scale-105"
            onClick={() => window.open(FACEBOOK_PAGE_URL, "_blank")}
          >
            <video
              className="w-full h-52 object-cover"
              src={videoSrc}
              muted
              controls={false}
              loop
              autoPlay
              playsInline
              preload="none"
            />
            {/* Overlay Facebook */}
            <div className="absolute inset-0 flex flex-col justify-center items-center bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity">
              <FaFacebookSquare className="text-white text-5xl mb-2 drop-shadow-xl" />
              <span className="text-white text-lg font-semibold drop-shadow-md">Ver en Facebook</span>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-8">
        <a
          href={FACEBOOK_PAGE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-3 bg-blue-700 hover:bg-blue-800 text-white font-bold px-8 py-4 rounded-2xl shadow-lg text-lg transition-all"
        >
          <FaFacebookSquare className="text-2xl" />
          Visitar página de Facebook
        </a>
      </div>
    </section>
  );
}
